import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var TextAreaSvg = function TextAreaSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2 18.12 20.224 2.25l.854 1.162L2.854 19.283zM9.277 19.62l11.39-10.416.88 1.14-11.39 10.415zM21.125 16.146l-5.467 4.96.875 1.143L22 17.289z"
  }));
};
export var TextArea = function TextArea(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: TextAreaSvg
  }));
};